export var ConditionOperatorEnum;
(function (ConditionOperatorEnum) {
    ConditionOperatorEnum["And"] = "And";
    ConditionOperatorEnum["Or"] = "Or";
    ConditionOperatorEnum["Equals"] = "Equals";
    ConditionOperatorEnum["NotEquals"] = "Not Equals";
    ConditionOperatorEnum["In"] = "In";
    ConditionOperatorEnum["NotIn"] = "Not In";
    ConditionOperatorEnum["Contains"] = "Contains";
    ConditionOperatorEnum["NotContains"] = "Not Contains";
    ConditionOperatorEnum["ContainsNoneOf"] = "Contains None Of";
    ConditionOperatorEnum["ContainsAnyOf"] = "Contains Any Of";
    ConditionOperatorEnum["ContainsAllOf"] = "Contains All Of";
    ConditionOperatorEnum["StartsWith"] = "Starts With";
    ConditionOperatorEnum["NotStartsWith"] = "Not Starts With";
    ConditionOperatorEnum["EndsWith"] = "Ends With";
    ConditionOperatorEnum["NotEndsWith"] = "Not Ends With";
    ConditionOperatorEnum["From"] = "From";
    ConditionOperatorEnum["To"] = "To";
})(ConditionOperatorEnum || (ConditionOperatorEnum = {}));
